// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Actions
import { fetchCurrentUser, setCurrentUserGuest } from '../../user/currentUserActions';

const mapDispatchToProps = (dispatch) => ({
    initialiseCurrentUser: () => dispatch(fetchCurrentUser()),
    setGuestUser: (user) => dispatch(setCurrentUserGuest()),
});

/**
 * This component is the same as the WorkspaceInitialisationDecorator, however it doesn't run the
 * initialiseFullWorkspace action because that's only needed when the full app workspace is being
 * rendered, not for previews or redirects.
 */
export default (DecoratedComponent) => {
    @connect(null, mapDispatchToProps)
    class WorkspaceUserOnlyInitialisationDecorator extends React.Component {
        // FIXME - Change from deprecated functions
        componentWillMount() {
            this.initialise(this.props);
        }

        // FIXME - Change from deprecated functions
        componentWillReceiveProps(nextProps) {
            if (!nextProps.isGuest && this.props.isGuest) this.initialise(nextProps);
        }

        initialise = (props) => {
            const { initialiseCurrentUser, isUserAvailable, isGuest, setGuestUser } = props;

            if (!isUserAvailable) initialiseCurrentUser();
            if (isGuest) setGuestUser();
        };

        render() {
            return <DecoratedComponent {...this.props} />;
        }
    }

    WorkspaceUserOnlyInitialisationDecorator.propTypes = {
        isGuest: PropTypes.bool,
        isUserAvailable: PropTypes.bool,
        initialiseCurrentUser: PropTypes.func,
        setGuestUser: PropTypes.func,
    };

    return WorkspaceUserOnlyInitialisationDecorator;
};
